import React from "react";

import {
  List,
  DataTable,
  TextField,
  SimpleForm,
  TextInput,
  ReferenceInput,
  Edit,
  Create,
  Show,
  EditButton,
  Pagination,
  NumberInput,
  ReferenceField,
  SelectInput,
  useRecordContext,
  required,
  SimpleShowLayout,
  Button,
  NumberField,
  TopToolbar,
  ColumnsButton,
  FilterButton,
} from "react-admin";
import { Link } from "react-router-dom";

// Lib
import { hasScope, SCOPE } from "../lib/auth";
import { DetailsButton } from "../lib/detailsButton";
import { VolumeField } from "../lib/volume";
import { custInfo } from "../lib/customer";

//MUI
import { CustomDatetimeField, CustomDateTimeInput } from "../lib/datetime";
import BarChartIcon from "@mui/icons-material/BarChart";
const linkBlue = "#005AA8";
const styles = {
  vcButton: {
    "&:enabled": {
      color: linkBlue,
    },
  },
};
const ViewGrafanaButton = () => {
  const record = useRecordContext();
  let iwmDashboard = custInfo.customerPreferences.iwmDashboard;

  if (iwmDashboard === undefined) {
    if (hasScope(SCOPE.ADMIN)) {
      iwmDashboard =
        "https://grafana.barrelwise.ca/d/bduu226fl3f28f/water-meters-usage?orgId=8&";
    } else {
      return null;
    }
  }

  try {
    const from = new Date(record.startTime).toISOString();
    const to = new Date(record.endTime).toISOString();

    return (
      <Button
        label="Grafana"
        component={Link}
        target="_blank"
        to={`${iwmDashboard}from=${from}&to=${to}&timezone=browser&var-customer_id=${record.customerID}`}
        sx={styles.vcButton}
      >
        <BarChartIcon />
      </Button>
    );
  } catch (error) {
    return;
  }
};

const WaterUseAppBarTitle = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <span> {"Water Use Session " + record.id}</span>;
};

const waterUseFilters = [
  <ReferenceInput source="deviceID" label="Device" reference="devices">
    <SelectInput optionText="serial" label="Device" />
  </ReferenceInput>,
  <TextInput source="category" label="Category" />,
];

export const WaterUseList = () => (
  <List
    perPage={100}
    pagination={<Pagination rowsPerPageOptions={[100, 200, 500, 1000]} />}
    filters={waterUseFilters}
    actions={
      <TopToolbar>
        <FilterButton />
        <ColumnsButton />
      </TopToolbar>
    }
    sort={{ field: "startTime", order: "DESC" }}
    storeKey={false}
    empty={false}
  >
    <DataTable bulkActionButtons={false} rowClick={false}>
      <DataTable.Col source="category" label="Category" disableSort>
        <TextField source="category" label="Category" />
      </DataTable.Col>
      <DataTable.Col source="volume" label="Volume" disableSort>
        <VolumeField source="volume" precision={1} />
      </DataTable.Col>
      <DataTable.Col source="startTime" label="Start Time">
        <CustomDatetimeField source="startTime" label="Start Time" />
      </DataTable.Col>
      <DataTable.Col source="endTime" label="End Time">
        <CustomDatetimeField source="endTime" label="End Time" />
      </DataTable.Col>
      <DataTable.Col source="deviceID" label="Device" disableSort>
        <ReferenceField source="deviceID" reference="devices" sortable={false}>
          <TextField source="serial" />
        </ReferenceField>
      </DataTable.Col>
      <DataTable.Col disableSort>
        <ViewGrafanaButton />
      </DataTable.Col>
      <DataTable.Col>
        <DetailsButton />
      </DataTable.Col>
      {hasScope(SCOPE.MANAGER) && (
        <DataTable.Col>
          <EditButton />
        </DataTable.Col>
      )}
    </DataTable>
  </List>
);

const CreateEditForm = () => (
  <SimpleForm>
    <CustomDateTimeInput
      label="Start Time"
      source="startTime"
      defaultValue={new Date()}
      readOnly
    />
    <CustomDateTimeInput
      label="End Time"
      source="endTime"
      defaultValue={new Date()}
      readOnly
    />
    <TextInput label="Category" source="category" validate={required()} />
    <NumberInput
      label="Volume (L)"
      source="volume"
      validate={required()}
      readOnly
    />
    <NumberInput label="Temperature" source="temperature" readOnly />
  </SimpleForm>
);

export const WaterUseEdit = () => (
  <Edit title={<WaterUseAppBarTitle />} redirect="list">
    <CreateEditForm />
  </Edit>
);

export const WaterUseCreate = () => (
  <Create redirect="list">
    <CreateEditForm />
  </Create>
);

export const WaterUseShow = () => (
  <Show title={<WaterUseAppBarTitle />}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <CustomDatetimeField
        source="startTime"
        label="Start Time"
        sortable={false}
      />
      <CustomDatetimeField source="endTime" label="End Time" sortable={false} />
      <TextField source="category" label="Category" />
      <VolumeField source="volume" precision={1} />
      <NumberField source="temperature" label="Temperature" />
      <TextField source="deviceID" label="Device ID" />
    </SimpleShowLayout>
  </Show>
);
